import React from 'react'
import { Block } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import TagList from '../../shared/TagList'
import './style.css'
import { Validations } from '@/utils/validations'

const Specialties = ({ serviceCategories }) => {

    return (
        <Block isRender={!Validations.isArrayEmpty(serviceCategories)}>
            <SectionCard icon="mdi:stethoscope" titleKey="service-categories">
                <TagList items={serviceCategories} />
            </SectionCard>
        </Block>
    )
}

export default Specialties

